import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";

const FAQS = [
    ["Is it safe?", "Safety comes first. Every participant completes a health questionnaire, groups are small, and every skill is introduced slowly on padded mats. The introductory workshop includes no falling practice."],
    ["Do I need experience?", "None. Everything is taught from the beginning, at your pace."],
    ["Is this martial arts?", "No. Some techniques are adapted from judo, which has taught people to fall safely for more than a century. There's no sparring, throwing or contact."],
    ["Where and when?", "The first workshops will be in Arlington, Virginia, in early 2027. Join the interest list to hear dates first."],
    ["What does it cost?", "Introductory workshops will be free or low cost. Course pricing will be announced with the first dates."],
    ["Can my organization host a workshop?", "Yes. Use the organization form below and Sarah will be in touch."],
];

export default function Faq() {
    return (
        <section id="faq" className="scroll-mt-24 pb-10 sm:pb-14 lg:pb-28">
            <div className="mx-auto max-w-4xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="Questions" title="Frequently asked" />
                </Reveal>
                <Reveal delay={0.1}>
                    <Accordion type="single" collapsible className="mt-10">
                        {FAQS.map(([q, a], i) => (
                            <AccordionItem key={i} value={`faq-${i}`} className="border-clay">
                                <AccordionTrigger
                                    data-testid={`faq-question-${i + 1}`}
                                    className="py-5 text-left text-lg font-bold text-ink hover:text-teal-700 hover:no-underline"
                                >
                                    {q}
                                </AccordionTrigger>
                                <AccordionContent className="text-lg leading-relaxed text-ink-soft">
                                    {a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}